import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import { Title, Text } from '../elements';
import { NoCode, CodeInput } from './elements';
import Spa24 from 'dc/Spa24';
import { useText } from 'common/hooks';

const deps = {
  campaign: state.account.joinCampaign.campaign,
  organisationName: state.account.joinCampaign.campaign.organisation.name,
};

export function Code({
  campaign,
  organisationName,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <>
      <Title>
        {campaign?.name
          ? t('account.join_campaign.code.title_with_name', {
              campaignName: campaign.name,
              organisationName: organisationName,
            })
          : t('account.join_campaign.code.title')}
      </Title>
      <Text>{t('account.join_campaign.code.sub_title')}</Text>
      <CodeInput />
      {!campaign?.name && (
        <>
          <Spa24 />
          <NoCode>{t('account.join_campaign.code.no_code')}</NoCode>
        </>
      )}
    </>
  );
}

export default connect(deps, Code);
